import React,{useState,useContext} from "react";
import { MDBInput } from "mdb-react-ui-kit";

import Select from "react-select";

import logo from "../../../assets/img/logo.png";
import noperson from "../../../assets/img/noperson.svg";
import LoadingScreen from "react-loading-screen";
import ResponsivePagination from 'react-responsive-pagination';
import 'react-responsive-pagination/themes/classic.css';

// reactstrap components
import {
  Badge,
  Button,
  Card,
  CardBody,
  Table,
  Row,
  Col,
  Modal,
  ModalBody,
} from "reactstrap";
import axios from "axios";
import { DELETE_USER, VIEW_USER, ROLE_LIST, EDIT_USER,INSERT_USER,UPDATE_USER,BASE_URL_CHAT_WHATSAPP } from "../../../constants";

import NotificationAlert from "react-notification-alert";

import moment from "moment";
import Papa from 'papaparse';
import * as XLSX from 'xlsx';

import { useHistory } from "react-router-dom";
import userContext from "../../../context/UserContext";
const ImageModel = () => {
    let drpdwn = [];
    const data = useContext(userContext);
  
  const [modalClassic, setModalClassic] = React.useState(false);
  const [singleSelect, setsingleSelect] = React.useState("");
  const [singletypeSelect, setsingleTypeSelect] = React.useState("");
  const [levelSelect, setLevelSelect] = React.useState("");

  const [singleChnlSelect, setsingleChnlSelect] = React.useState("");
  const [isActive, setIsActive] = React.useState(false);
  const [updateUserId, setUpdateUserId] = React.useState(0);
  const notificationAlertRef = React.useRef(null);

  const [isLoading, setIsLoading] = React.useState(true);
  const [countHistory,setCountHistory] = useState({user:"",history:[],count:0})
 
  const navigate = useHistory();
  let lcObj = localStorage.getItem("user");
  let lclStrge = JSON.parse(lcObj);

  const initialState = {
    username: "",
    password: "",
    mobile: "",
    email: "",
    senderId:lclStrge.sender_id,
    count: 0,
    client:"",
    firstName:"",
    lastName:"",
    profile:noperson
  };

  const initialData= {
    name: "",
    file: "",
    targetFile: "",
    optimizer:"",
    client:"",
    lossunit:""
  };

  const toggleModalClassic = () => {
    setModalClassic(!modalClassic);
    setUsers(initialState)
  };
  


  const [textdata,setTextData]= useState(initialData);
  const [users, setUsers] = React.useState(initialState);
  const [usersList, setUsersList] = React.useState([]);
  const [roleList, setRoleList] = React.useState([]);
  const [currentPage, setCurrentPage] = React.useState(1);

  const[filterList,setFilterLst] = useState([]);
  const[trgtDrpDwn,setTrgtDrpDwn] = useState([]);


  const onchangeHandler = (e) => {
    const { name, value } = e.target;
   // setUsers({ ...users, [name]: value });
   setTextData({...textdata,[name]: value})
  };

  const[validate,setValidate] = useState({
    message:"",
    notValid:false
  })



  const chooseFile = (e) => {
    
    let a = e.target.value.split(".");
    const file = e.target.files[0];
    
    if (a[1] == "csv") {
       
        if (file) {
          Papa.parse(file, {
            complete: (result) => {
             
              result?.meta?.fields?.map((item, index) => {
               
                drpdwn.push({
                  value: item,
                  label: item,
                });
              });
           
            },
            header: true,
          });
        }
    
    } else if(a[1] == "xlsx") {
        
        const reader = new FileReader();

        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const jsonSheet = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
    
          if (jsonSheet.length > 0) {
            
            jsonSheet[0]?.map((item, index) => {
                drpdwn.push({
                  value: item,
                  label: item,
                });
              });
             
          }
        };
    
        reader.readAsArrayBuffer(file);
    }
    setTrgtDrpDwn(drpdwn);
    setTextData({...textdata,targetFile:""})
   
  };

  const submitInsertUser = () => {
   
    console.log("---->161--",textdata);
    // if(updateUserId){
    //  let resultuser={
    //     id:updateUserId.toString(),
    //     username: users.username,
    //     password: users.password,
    //     mobile: users.mobile,
    //     email: users.email,
    //     role: singleSelect.value,
    //     tuserstatus: `${isActive?"inactive":"active"}`,
    //     usertype: singletypeSelect.value,
    //     channel: singleChnlSelect.value,
    //     agenttype: levelSelect.value,
    //     senderId:users.senderId
    //   }
    //   setValidate({
    //     message:"",
    //     notValid:false
    //   })
   
    // axios
    //   .post(UPDATE_USER, resultuser)
    //   .then((response) => {
    //     setModalClassic(false);
    //     let options = {};
    //     options = {
    //       place: "tr",
    //       message: "Updated Successfully",
    //       type: "success",

    //       autoDismiss: 2,
    //     };
    //     notificationAlertRef.current.notificationAlert(options);
    //     setUsers(initialState);
    //     setsingleSelect(null);
    //     setsingleTypeSelect(null);
    //     setsingleChnlSelect(null);
    //     setLevelSelect(null);
    //     viewUserList(currentPage);
    //     setUpdateUserId(0)
    //   })
    //   .catch((error) => {
    //     console.log("catch--", error);
    //   });
    // }else{
    
    //   if(isvalidUser()){
    //     let resultuser = {
    //       username: users.username,
    //       password: users.password,
    //       mobile: users.mobile,
    //       email: users.email,
    //       role: singleSelect.value,
    //       tuserstatus: `${isActive?"inactive":"active"}`,
    //       usertype: singletypeSelect.value,
    //       channel:singleChnlSelect.value,
    //       agenttype:levelSelect.value,
    //       senderId:users.senderId
    //     };
    //     setValidate({
    //       message:"",
    //       notValid:false
    //     })
    //     axios
    //     .post(INSERT_USER, resultuser)
    //     .then((response) => {
    //       setModalClassic(false);
    //       let options = {};
    //       options = {
    //         place: "tr",
    //         message: "Saved Successfully",
    //         type: "success",
  
    //         autoDismiss: 2,
    //       };
    //       notificationAlertRef.current.notificationAlert(options);
    //       setUsers(initialState);
    //       setsingleSelect(null);
    //       setsingleTypeSelect(null);
    //       setLevelSelect(null);
    //       setsingleChnlSelect(null);
    //       viewUserList(currentPage);
    //       setUpdateUserId(0)
    //     })
    //     .catch((error) => {
    //       console.log("catch--", error);
    //     });
    //   }
      
  
    
    // }
  };

  const isvalidUser=()=>{
    if(users.username ==""){
      setValidate({
        message:"Please enter username",
        notValid:true
      })
      
      return false
    }else if(users.password.length<8){
      setValidate({
        message:"Password length shoud be greater than 8 charcters",
        notValid:true
      })
     
      return false;
    }else if(users.mobile.length != 12){
      setValidate({
        message:"Mobile Number  shoud be 12 digits",
        notValid:true
      })
     
      return false;
    }else if(users.email.length<5){
      setValidate({
        message:"Please Enter Email",
        notValid:true
      })
     
      return false;
    }else if(!users?.email.includes("@")){
      setValidate({
        message:"Please Enter Valid Email",
        notValid:true
      })
     
      return false;
    }else if(!users?.email.includes(".com")){
      setValidate({
        message:"Please Enter Valid Email",
        notValid:true
      })
     
      return false;
    }
    
    else if(singleSelect?.value== undefined){
      setValidate({
        message:"Please Select Role",
        notValid:true
      })
     
      return false;
    }else if(singletypeSelect?.value== undefined){
      
      setValidate({
        message:"Please Select User Type",
        notValid:true
      })
     
      return false;

    }
    else{
      setValidate({
        message:"",
        notValid:false
      })
     
      return true;
    }

   // users.username&&users.password&&users.mobile&&users.email

  }

  const createText =()=>{
    navigate.push("/admin/ai/image/createImageModel");
  }
  const viewUserList = (pageNo) => {
    axios
      .get(VIEW_USER + `?page=` + pageNo)
      .then((response) => {
        setUsersList(response.data);
        setFilterLst(response.data)
        setCurrentPage(pageNo);
        setIsLoading(false)
      })
      .catch((error) => {
        console.log("????", error);
      });
  };
  const roleDrpdwn = () => {
    axios
      .get(ROLE_LIST)
      .then((response) => {
        setRoleList(response.data.message);
      })
      .catch((error) => {
        console.log("????", error);
      });
  };
  React.useEffect(() => {
    viewUserList(1);
    roleDrpdwn();
  }, []);

 



  const editUser = (id) => {
    setUpdateUserId(id)
    setModalClassic(true);

    axios
      .post(EDIT_USER, { userid: id.toString() })
      .then((response) => {
        const res = response.data.message[0];
        setUsers({
          username: res.username,
          password: res.password,
          mobile: res.mobile,
          email: res.email,
          senderId: res.senderid
        });
        setsingleSelect({ value: res.role, label: res.role });
        setsingleChnlSelect({ value: res.channel, label: res.channel });

        res.tuserstatus == "active"? setIsActive(false) : setIsActive(true);
        //res.status === 0 ? setIsActive(false) : setIsActive(flase);
        let usertype = {};
        if (res.usertype === 2) {
          usertype = { value: "2", label: "Prepaid" };
        } else if (res.usertype === 3) {
          usertype = { value: "3", label: "Postpaid" };
        } else {
          usertype = { value: "", label: "Select User Type" };
        }
        setsingleTypeSelect(usertype);

        let agentLevel = {};
        if (res.agenttype === "level1") {
          agentLevel = { value: "level1", label: "Level 1" };
        } else if (res.agenttype === "level2") {
          agentLevel = { value: "level2", label: "Level 2" };
        } else if (res.agenttype === "level3") {
          agentLevel = { value: "level3", label: "Level 3" };
        } else {
          agentLevel = { value: "", label: "Select Level" };
        }
        setLevelSelect(agentLevel);
      })
      .catch((error) => {
        console.log("????", error);
      });
  };

  const deleteUser = async (id) => {
   
    await axios
      .post(DELETE_USER, { id:  id.toString()})
      .then((res) => viewUserList(currentPage))
      .catch((err) => console.log("--err-", err));
  };

  const filterData = (e) =>{
    let filter = e.target.value;

     let filterdata = filterList?.message.filter((item,index)=>{
      return (item.username.toString().includes(filter)
      ||moment(item.updatedat).format('DD-MM-YYYY').toString().includes(filter)
      ||item.role.toString().includes(filter)
      ||item.mobile.toString().includes(filter)
      ||item.email.toString().includes(filter)
      ||item.tuserstatus.toString().includes(filter)
      )})
     setUsersList({
      message: filterdata,
      numOfPages:filterList.numOfPages
    })
    // console.log("--221--",a);
    }

    const addCount =()=>{
      alert(countHistory.name)
      alert(countHistory.count)
    }

  return (
    <>
     <LoadingScreen
          children=""
          loading={isLoading}
          bgColor="rgba(0,0,0,0.7)"
          spinnerColor="#9ee5f8"
          textColor="#676767"
          logoSrc={logo}
          text="Loading..."
        ></LoadingScreen>
      <div className="content pd-0">
        <Row>
          <Card className="mb-0">
            <NotificationAlert ref={notificationAlertRef} />
            <CardBody>
              <Col sm="12">
                <Row>
                  <Col sm="9">
                    <h4 className="mt-4">
                      <Button
                        className="btn btn-icon btn-round btn-success"
                        onClick={
                       ()=> createText()  
                          //toggleModalClassic
                        }
                      >
                        <i class="tim-icons icon-simple-add"></i>
                      </Button>
                      {/* <a href="/admin/ai/text/textreports"> */}
                      Create Model
                      {/* </a> */}
                    </h4>
                  </Col>
                  <Col md='3' sm="12" className="mt-4">
                    <MDBInput label="Search" type="text" onChange={(e)=>filterData(e)} />
                  </Col>
                </Row>
              </Col>
              <Col sm="12" className="scroll-height-350">
                <Row>
                  <Table responsive striped>
                    <thead>
                      <tr>
                        <th> Name</th>
                        <th> Target File </th>
                        <th> Optimizer </th>
                        <th> Client </th>
                        <th> Actions </th>
                      </tr>
                    </thead>
                    <tbody>
                      {usersList?.message?.map((item, index) => {
                        return (
                          <React.Fragment key={index}>
                            <tr>
                              <td>{item.username}</td>
                              <td>{item.email}</td>
                              <td>{item.mobile}</td>
                              
                              <td>
                                {item.createdat
                                  ? moment(item.createdat).format("MMM-DD-YYYY")
                                  : "---"}
                              </td>
                              <td>
                                <a to="" className="text-info mr-2">
                                  <i
                                    class="tim-icons icon-pencil"
                                    onClick={() => editUser(item.id)}
                                  ></i>
                                </a>
                                <a
                                  to=""
                                  value={item}
                                  onClick={() =>deleteUser(item.id)}
                                  className="text-warning ml-2"
                                >
                                  <i className="tim-icons icon-trash-simple"></i>
                                </a>
                              </td>
                            </tr>
                          </React.Fragment>
                        );
                      })}
                
                    </tbody>
                  </Table>
                </Row>
              </Col>
            </CardBody>
            { usersList?.numOfPages>0&&
        <div style={{padding:"8px",marginLeft:"auto"}}>
        <ResponsivePagination
      current={currentPage}
      total={usersList?.numOfPages}
      onPageChange={(newPage )=>{viewUserList(newPage)}}
    />
    </div>
}
          </Card>

          <Modal isOpen={modalClassic} toggle={toggleModalClassic}>
            <div className="modal-header justify-content-center">
              <button
                aria-hidden={true}
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={toggleModalClassic}
              >
                <i className="tim-icons icon-simple-remove" />
              </button>
              <h3 className="title title-up multicolortext">{users?.username?"Edit Model":"Add Model"}</h3>
              
            </div>
            <ModalBody className="modelbody ">
         
              <Row>
              {validate.notValid&&<span style={{color:"red"}}>{validate.message}</span>}
              <Col sm="4" className="mb-2">
                  <MDBInput
                    label="Name"
                    type="text"
                    name="name"
                    value={textdata.name}
                    onChange={(e)=>onchangeHandler(e)}
                  />
                </Col>
                <Col sm="4" className="mb-2">
                <input
                    type="file"
                    id="file"
                    accept=".csv,.xlsx"
                        onChange={(e) => chooseFile(e)}
                   
                  />
                </Col>
                <Col sm="4" className="mb-2">
                  <Select
                    className="react-select info"
                    classNamePrefix="react-select"
                    name="targetfile"
                    value={textdata.targetFile}
                    onChange={(value) => {
                     setTextData({...textdata,targetFile:value})
                    }}
                    options={trgtDrpDwn}
                    placeholder="Select Target File"
                  />

                </Col>
                <Col sm="4" className="mb-2">
                  <Select
                    className="react-select info"
                    classNamePrefix="react-select"
                    name="optimizer"
                    value={users.client}
                    onChange={(value) => setUsers({...users,client:value})}
                    options={drpdwn}
                    placeholder="Select Optimizer"
                  />
                </Col>
                <Col sm="4" className="mb-2">
                  <Select
                    className="react-select info"
                    classNamePrefix="react-select"
                    name="client"
                    value={users.client}
                    onChange={(value) => setUsers({...users,client:value})}
                    options={drpdwn}
                    placeholder="Select Client"
                  />
                </Col>
                <Col sm="4" className="mb-2">
                  <Select
                    className="react-select info"
                    classNamePrefix="react-select"
                    name="lossunit"
                    value={users.client}
                    onChange={(value) => setUsers({...users,client:value})}
                    options={drpdwn}
                    placeholder="Select Loss Unit"
                  />
                </Col>
            
                
              
                <Col sm="12" className="">
                  <Button
                    type="submit"
                    className="btn btn-icon btn-primary mt-4 pull-right"
                    onClick={()=>submitInsertUser()}
                  >
                    <i className="tim-icons icon-double-right"></i>
                  </Button>
                </Col>
           
              </Row>
            </ModalBody>
          </Modal>
        
        </Row>
      </div>
    </>
  );
};


export default ImageModel;